export enum IntakeDocumentSubmissionTypeCode {
  PRO = 'PRO',
  CO = 'CO',
  DEL = 'DEL',
  OTH = 'OTH',
  EL_SOW = 'EL/SOW',
}

export enum IntakeSubmissionTypeName {
  PRO = 'Proposal',
  CO = 'Change Order',
  DEL = 'Deliverable',
  OTH = 'Other',
  EL_SOW = 'Engagement Letter / Statement of Work',
}

export const IntakeSubmissionTypeIDMapper: Record<
  IntakeDocumentSubmissionTypeCode,
  number
> = {
  [IntakeDocumentSubmissionTypeCode.PRO]: 1,
  [IntakeDocumentSubmissionTypeCode.EL_SOW]: 2,
  [IntakeDocumentSubmissionTypeCode.CO]: 3,
  [IntakeDocumentSubmissionTypeCode.DEL]: 4,
  [IntakeDocumentSubmissionTypeCode.OTH]: 5,
};
